/**
 * Limit focus inside a given html element
 * @param {string} elementId ID of the given element
 */
function limitFocusInside(elementId) {
    // current index
    let currentFocusIndex = 0;
    return function (event) {
        // Intercept the changing focus event
        let injectedDiv = document.getElementById(elementId);
        // Get all focusable element inside the given div
        let focusableElements = injectedDiv.querySelectorAll('a, [role="button"], button, input, select, textarea');
        if (event.key === 'Tab') {
            // Forbid default focus changing event
            event.preventDefault();

            if (focusableElements && focusableElements.length > 0) {
                // Move focus to next element
                currentFocusIndex = (currentFocusIndex + 1) % focusableElements.length;
                focusableElements[currentFocusIndex].focus();
            }
        }
    };
}

/**
 * Add the limitation of focus
 * @param {string} elementId ID of the given element
 */
function addFocusLimitation(elementId) {
    // Intercept the changing focus event
    document.body.addEventListener('keydown', limitFocusInside(elementId));
}

/**
 * Remove the limitation of focus
 */
function removeFocusLimitation(elementId) {
    document.body.removeEventListener('keydown', limitFocusInside(elementId));
}





export {addFocusLimitation, removeFocusLimitation};